import { Link } from 'react-router-dom'
import MetaTags from '../components/MetaTags'
import { imageUrl } from '../lib/images'

export default function FinansieringPage({ settings }) {
  const phone = settings?.phone || '22 18 73 30'
  const phoneRaw = settings?.phone_raw || '22187330'
  const indicataUrl =
    settings?.indicata_url ||
    'https://lg.indicata.com/#/?dealerId=156f3c15-a501-4045-bf19-5598ec416fd9'

  return (
    <>
      <MetaTags
        title="Finansiering/Motor forsikring | EK Biler v/Steen Svensson Ek"
        description="Santander eller Accept Auto er specialister i lån til biler. Finansiering og motorforsikring med eller uden udbetaling hos EK Biler i Hejnsvig."
        ogTitle="Finansiering/Motor forsikring | EK Biler v/Steen Svensson Ek"
        ogDescription="Santander eller Accept Auto er specialister i lån til biler. Finansiering og motorforsikring med eller uden udbetaling hos EK Biler i Hejnsvig."
        ogImage={imageUrl('bil-vit.jpg', 'width=1200,quality=85,format=auto')}
      />

      {/* Hero Header */}
      <section className="bg-[#14171a] text-white py-14 sm:py-20 border-b border-[#262c33] relative overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-15">
          <img
            src={imageUrl('bil-vit.jpg', 'width=1600,quality=80,format=auto')}
            alt="Finansiering og motorforsikring"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6">
          <div className="max-w-3xl space-y-4">
            <div className="flex items-center gap-2 text-xs font-bold text-gray-400 uppercase tracking-wider">
              <Link to="/" className="hover:text-white">Forside</Link>
              <span>/</span>
              <span className="text-[#e20019]">Bilsalg</span>
            </div>
            <h1 className="text-3xl sm:text-5xl font-extrabold tracking-tight text-white">
              Finansiering/Motor forsikring
            </h1>
            <p className="text-gray-300 text-base sm:text-lg leading-relaxed">
              Santander eller Accept Auto er specialister i lån til biler. Få et attraktivt og
              fordelagtigt billån hos EK Biler – med eller uden udbetaling.
            </p>
            <div className="pt-2 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 w-full sm:w-auto">
              <a
                href={`tel:${phoneRaw}`}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#e20019] hover:bg-[#b80014] text-white px-6 py-3 rounded-xl font-bold text-sm shadow-md transition-all whitespace-nowrap text-center"
              >
                <i className="fa-solid fa-phone" aria-hidden="true" />
                <span>Ring og hør nærmere: {phone}</span>
              </a>
              <a
                href={indicataUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#20252c] hover:bg-[#2b323c] border border-gray-700 text-white px-5 py-3 rounded-xl font-bold text-sm transition-colors whitespace-nowrap text-center"
              >
                <span>Beregn byttepris online</span>
                <i className="fa-solid fa-arrow-up-right-from-square text-xs text-gray-400" aria-hidden="true" />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content from Scrape */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="max-w-7xl mx-auto space-y-12 text-gray-800 leading-relaxed text-base">
            <div>
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
                Santander eller Accept Auto er specialister i lån til biler
              </h2>
              <p>Tjek altid din banks generelle vilkår, inden du vælger dem til finansiere din næste bil.</p>
              <p className="mt-3">
                Kom ind hos <strong className="text-gray-900">EK Biler</strong> og hør om fordelene
                ved at låne til din bil hos os i stedet for i banken.
              </p>
              <ul className="list-disc list-inside space-y-2 mt-4 pl-2 text-gray-700">
                <li>Proff. rådgivning</li>
                <li>Det tager kun få minutter at beregne et forslag, der passer til din økonomi.</li>
                <li>Lige nu har vi rente tilbud helt ned til 1,99 %</li>
                <li>Det afhænger af hvor gammel bilen er.</li>
              </ul>
              <p className="mt-4 font-semibold text-gray-900">
                Lad os klare finansiering og lad de fornuftige priser og gode vilkår komme dig til gode.
              </p>
              <div className="mt-4 p-4 rounded-xl bg-gray-50 border border-gray-200 text-sm flex flex-wrap items-center gap-2">
                <span>Ring på</span>
                <a href={`tel:${phoneRaw}`} className="text-[#e20019] font-bold hover:underline">
                  {phone}
                </a>
                <span>eller</span>
                <Link to="/kontakt" className="text-[#e20019] font-bold hover:underline">
                  send en mail
                </Link>
                <span>og få et personligt tilbud og hør nærmere om de gode vilkår!</span>
              </div>
            </div>

            <div className="bg-gray-50 rounded-2xl p-6 sm:p-8 border border-gray-200">
              <p className="text-sm sm:text-base leading-relaxed">
                Papirerne underskriver du også hos EK Biler, når du har truffet aftale om vilkårene. Her
                hjælper vi med finansieringen. Få dit billån via Accept Auto – det er nemt og billigt!
                Få finansieret dit bilkøb hos os. Her får du et attraktivt og fordelagtigt billån, det
                er hurtigere og nemmere end du tror.
              </p>
              <p className="mt-3 text-sm sm:text-base leading-relaxed">
                Med eller uden udbetaling, vi hjælper dig sikkert på vej. Duften af din nye drømmebil
                sidder i næsen, og du vil bare gerne ud at køre. Spring møderne i banken over, hos os
                får du svar mens du venter.
              </p>

              <h3 className="font-bold text-gray-900 text-lg mt-6 mb-3">Dine fordele:</h3>
              <ul className="list-disc list-inside space-y-2 pl-2 text-gray-700 text-sm">
                <li>Markedets bedste muligheder</li>
                <li>Hurtigt svar på dit billån</li>
                <li>Du bevarer dine lånemuligheder i banken</li>
              </ul>

              <div className="mt-6 p-4 rounded-xl bg-amber-50 border border-amber-200 text-amber-900">
                <h4 className="font-bold text-base">Få et Guldlån</h4>
                <p className="text-sm mt-0.5">Billån fra 0,- i udbetaling</p>
              </div>
            </div>

            {/* ØkonomiSikring */}
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                Beskyt dig med ØkonomiSikring – valget er dit!
              </h3>
              <p>
                ØkonomiSikring betaler den månedlige ydelse på dit billån, hvis du bliver ufrivilligt
                arbejdsløs eller midlertidigt uarbejdsdygtig, imens du betaler af på dit billån. Når du
                finansierer din bil via Accept Auto, får du de 3 første måneder gratis. Så er du dækket,
                så snart du begynder at betale for forsikringen – det synes vi er mest fair.
              </p>
              <p className="mt-3 text-sm text-gray-600">
                Du bliver kontaktet i løbet af de 3 første måneder af lånets løbetid, med tilbud om at
                købe ØkonomiSikring. Den fordelagtige pris gør, at det kun er muligt at købe
                ØkonomiSikring inden for de første 3 måneder.
              </p>
            </div>

            {/* Fragus */}
            <div className="border-t border-gray-200 pt-10">
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                Slip for bekymringer, når du køber brugt bil med Fragus
              </h3>
              <p>
                Fragus forlænger bilens garantiperiode og giver derved større tryghed til dig, når du
                køber brugt bil.
              </p>
              <p className="mt-3">
                Garantien kan tilkøbes til alle vores personbiler samt varevogne både el-, hybrid- og
                fossilbiler. Fragus er markedets bedst dækkende og mest fleksible garantiprodukt til
                brugte biler i alderen 2–9 år.
              </p>
              <p className="mt-3">
                Bekymringer for uventede værkstedsregninger skal ikke holde dig tilbage, når du kigger
                efter en brugt bil. For med Fragus har du styr på budgettet og undgår ubehagelige
                overraskelser, takket være den omfattende garantidækning.
              </p>

              <div className="bg-gray-50 p-6 rounded-xl border border-gray-200 my-6 space-y-2 text-sm">
                <div>
                  <strong>Fragus målgruppe:</strong> Alle bilmærker og modeller i alderen 2-9 år –
                  gælder både elbil, hybridbil og fossilbil.
                </div>
                <div><strong>Selvrisiko:</strong> 0,-</div>
                <div><strong>Opkrævning:</strong> Engangsbetaling ved køb af bil eller fornyelse af garanti.</div>
                <div><strong>Opkrævningsstart:</strong> Tegningstidspunkt.</div>
                <div>
                  <strong>Max varighed:</strong> Indtil bilen fylder 10 år eller har kørt i alt 200.000
                  km (det, der kommer først).
                </div>
                <div>
                  <strong>Krav for gyldighed:</strong> Alle serviceeftersyn skal overholdes efter
                  fabrikkens krav og med en tolerance på maksimum +60 dage / +3.000 km.
                </div>
              </div>

              <p className="text-sm text-gray-700">
                Fragus fås til alle biler, der er over 24 mdr., og du kan selv bestemme, om du ønsker at
                udvide garantien i 24-, 36- eller 48 mdr.
              </p>

              {/* Pricing Cards */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 my-8">
                <div className="p-6 bg-white rounded-xl border-2 border-gray-200 text-center shadow-sm">
                  <h4 className="font-bold text-lg text-gray-900 mb-2">24 mdr. garanti</h4>
                  <div className="text-2xl font-black text-[#e20019]">DKK 4.995,-</div>
                  <div className="text-xs text-gray-500 line-through mt-0.5">Normalpris 6.995,-*</div>
                  <div className="text-xs text-gray-600 mt-3 pt-3 border-t border-gray-100">
                    Ved finansiering over 72 mdr.**<br />
                    <strong className="text-gray-900">Kun 59,- pr. måned</strong>
                  </div>
                </div>

                <div className="p-6 bg-white rounded-xl border-2 border-[#e20019] text-center shadow-md relative">
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#e20019] text-white text-[11px] font-bold px-3 py-0.5 rounded-full uppercase tracking-wider">
                    Populær
                  </div>
                  <h4 className="font-bold text-lg text-gray-900 mb-2">36 mdr. garanti</h4>
                  <div className="text-2xl font-black text-[#e20019]">DKK 7.995,-</div>
                  <div className="text-xs text-gray-500 line-through mt-0.5">Normalpris 9.995,-*</div>
                  <div className="text-xs text-gray-600 mt-3 pt-3 border-t border-gray-100">
                    Ved finansiering over 72 mdr.**<br />
                    <strong className="text-gray-900">Kun 99,- pr. måned</strong>
                  </div>
                </div>

                <div className="p-6 bg-white rounded-xl border-2 border-gray-200 text-center shadow-sm">
                  <h4 className="font-bold text-lg text-gray-900 mb-2">48 mdr. garanti</h4>
                  <div className="text-2xl font-black text-[#e20019]">DKK 8.995,-</div>
                  <div className="text-xs text-gray-500 line-through mt-0.5">Normalpris 10.995,-*</div>
                  <div className="text-xs text-gray-600 mt-3 pt-3 border-t border-gray-100">
                    Ved finansiering over 72 mdr.**<br />
                    <strong className="text-gray-900">Kun 109,- pr. måned</strong>
                  </div>
                </div>
              </div>
            </div>

            {/* Stellet på en bil (Chassis image and breakdown) */}
            <div className="border-t border-gray-200 pt-10">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Stellet på en bil</h3>
              <div className="rounded-2xl overflow-hidden border border-gray-200 shadow-md mb-8">
                <img
                  src={imageUrl('bil-vit.jpg', 'width=1200,quality=90,format=auto')}
                  alt="Stellet på en bil - komponenter og dækning"
                  className="w-full h-auto object-contain bg-white"
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm">
                <div className="p-5 bg-gray-50 rounded-xl border border-gray-200 space-y-1">
                  <h4 className="font-bold text-gray-900 text-base">Motor</h4>
                  <p className="text-gray-600 leading-relaxed text-xs">
                    Topstykke og alle oliesmurte komponenter såsom stempler, krumtap, knastaksel,
                    ventiler, ventilløftere, plejlstænger, plejlstangslejer og oliepumpe,
                    motortemperaturføler, impulsføler, atmosfæretrykmåler, luftmassemåler,
                    brændstofpumpe, trykventiler, indsprøjtningsdyser og tankarmatur.
                  </p>
                </div>

                <div className="p-5 bg-gray-50 rounded-xl border border-gray-200 space-y-1">
                  <h4 className="font-bold text-gray-900 text-base">Gearkasse og drivaksler</h4>
                  <p className="text-gray-600 leading-relaxed text-xs">
                    Alle gearkassens indre bevægelige dele, koblingens slavecylinder og hoved cylinder
                    koblingsrør, koblingsleje, svinghjul, driv- og kardanaksler.
                  </p>
                </div>

                <div className="p-5 bg-gray-50 rounded-xl border border-gray-200 space-y-1">
                  <h4 className="font-bold text-gray-900 text-base">Aircondition</h4>
                  <p className="text-gray-600 leading-relaxed text-xs">
                    Kabineblæsermotor, kabinekøler (evaporator), kompressor, kondenser, styreenhed,
                    kondensator og betjeningspanel.
                  </p>
                </div>

                <div className="p-5 bg-gray-50 rounded-xl border border-gray-200 space-y-1">
                  <h4 className="font-bold text-gray-900 text-base">Drivline &amp; Motorkøling</h4>
                  <p className="text-gray-600 leading-relaxed text-xs">
                    Drivaksler (ikke defekte gummidæksler, yderlejer elbil). Termostat, vandpumpe,
                    motorkøler- / ventilatormotor. Højvoltbatteriets kølesystem (elbil).
                  </p>
                </div>

                <div className="p-5 bg-gray-50 rounded-xl border border-gray-200 space-y-1">
                  <h4 className="font-bold text-gray-900 text-base">Bremsesystem &amp; Styresystem</h4>
                  <p className="text-gray-600 leading-relaxed text-xs">
                    Hoved bremsecylinder, bremse servo, bremserør, bremsekraftforstærker og
                    bremsevæskebeholder, ABS-hydraulikaggregat, ABS føler og styreenhed. Servopumpe,
                    ratstamme og styrehus.
                  </p>
                </div>

                <div className="p-5 bg-gray-50 rounded-xl border border-gray-200 space-y-1">
                  <h4 className="font-bold text-gray-900 text-base">Turbo, Airbags &amp; Elektronik</h4>
                  <p className="text-gray-600 leading-relaxed text-xs">
                    Turbo-aggregatets indre bevægelige dele, ladeluftkøler. Alle airbags og sensorer.
                    Startmotor, generator, motorstyreenhed, ECU, ECM styreenhed, omformer DC/AC og
                    DC/DC (elbil), el-ruder, spejle, centrallås.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
